import * as React from 'react'

import { Email, FormGroup, PhoneNumberInput, Util } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { countriesOrder } from '../../../configuration/phone-number-input'
import { FormProps } from '../types'

const ContactDetailsForm: React.FC<FormProps> = () => {
  const { getLabel, country, locale } = useIntl()
  return (
    <React.Fragment>
      <FormGroup>
        <Email
          label={getLabel('checkout.contact.email')}
          errorMessage={getLabel('checkout.contact.email.errorMessage')}
          validations={[Util.validations.isEmailAddress]}
          maxLength={80}
        />
      </FormGroup>
      <FormGroup>
        <PhoneNumberInput
          id="phone"
          required={true}
          label={getLabel('checkout.contact.phoneNumber')}
          defaultCountry={country}
          localeForTranslations={locale}
          countriesOrder={countriesOrder}
          initialState={{
            value: '',
            isValid: undefined,
            isTouched: undefined,
          }}
          errorMessage={getLabel('checkout.contact.phoneNumber.errorMessage')}
          optionalText={getLabel('checkout.form.field.optional')}
          hideAsteriskSign={false}
        />
      </FormGroup>
    </React.Fragment>
  )
}

export default ContactDetailsForm
